import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import CustomDataTable from "../../../components/CustomDataTable";
import * as api from "../../../services/apiService";
import "./ProblemListPage.scss"

function ProblemListPage() {
  const [title, setTitle] = useState('');
  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const ref = useRef();

  async function confirmDelete() {
    if (selectedId !== null) {
      const response = await api.deleteComplaint(selectedId);

      switch (response.status) {
        case 200:
          console.log("success");
          break;
        default:
          console.log("fail");
      }

      ref.current?.refresh();
    }
    setIsPopupVisible(false);
    setSelectedId(null);
  }

  function handleDelete(id) {
    setSelectedId(id);
    setIsPopupVisible(true);
  }

  function closePopup() {
    setIsPopupVisible(false);
    setSelectedId(null);
  }

  const columns = [
    {
      name: "Organizaţie",
      selector: (row) => row.organization,
    },
    {
      name: "Utilizator",
      selector: (row) => row.user,
    },
    {
      name: "Data",
      selector: (row) => row.dateAdded,
    },
    {
      name: "Publicat",
      selector: (row) => (row.published ? "Da" : "Nu"),
    },
    {
      name: "Plangere",
      selector: (row) => row.title,
    },
    {
      name: "Status",
      selector: (row) => (row.status ? "Rezolvat" : "Initiat"),
    },
    {
      name: "Acţiuni",
      cell: (row) => (
        <div className="actions-cell">
          <span
            onClick={() => handleDelete(row.id)}
            className="p-1 rounded"
          >
            <img src="../images/delete.png" alt="Delete" className="icon red" />
          </span>

          <Link
            to={`/dashboard/problem/edit/${row.id}`}
            className="p-1 rounded"
          >
            <img src="../images/edit.png" alt="Edit" className="icon blue" />
          </Link>

          <Link
            to={`/dashboard/problem/share/${row.id}`}
            className="p-1 rounded"
          >
            <img src="../images/ShareIcon.png" alt="Share" className="icon green" />
          </Link>
        </div>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: "160px",
    },
  ];


  function handleSearch() {
    ref.current?.refresh();
  }

  function setSearchTitle(e) {
    setTitle(e.target.value);
  }

  return (
    <div id="problemList">
      <div className="my-4 d-flex justify-content-center gap-2">
        <input
          type="search"
          className="px-4 py-2 w-50 text-black rounded"
          placeholder="Căutare..."
          onChange={setSearchTitle}
        />

        <button
          onClick={handleSearch}
          className="px-4 py-2 text-white rounded btn"
        >
          Căutare
        </button>
      </div>

      <div className="overflow-x-auto">
        <CustomDataTable
          columns={columns}
          title="Petiţii"
          fetchUrl="/api/Complaint/Search"
          filters={{
            title: title,
          }}
          ref={ref}
        />
      </div>

      {isPopupVisible && (
        <div className="popup">
          <div className="confirm p-3 rounded">
            <p className="mb-4 popupText fw-bold">Ești sigur că vrei să ștergi această înregistrare?</p>
            <div className="d-flex justify-content-end gap-4">
              <button
                onClick={confirmDelete}
                className="px-4 py-2 rounded btnPopup"
              >
                Da
              </button>
              <button
                onClick={closePopup}
                className="px-4 py-2 rounded btnPopup"
              >
                Nu
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default ProblemListPage;
